import React from 'react';

const ToggleButtonGroup = (props) => (
	<div className={props.vertical ? "toggle-button-group toggle-button-group-vertical" : "toggle-button-group"}>
		{props.options.map(option => {
			const [ label, value ] = option;

			return (
				<div className="toggle-button" key={value}>
					<input id={props.name + "_" + value} type="radio" name={props.name} value={value} onChange={props.changeHandler} />
					<label htmlFor={props.name + "_" + value}>{label}</label>
				</div>
			);
		})}
	</div>
);

export default ToggleButtonGroup;
